var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.625 40.3125H9.375C7.30312 40.3125 5.625 38.6344 5.625 36.5625V30.9375C5.625 28.8656 7.30312 27.1875 9.375 27.1875H35.625C37.6969 27.1875 39.375 28.8656 39.375 30.9375V36.5625C39.375 38.6344 37.6969 40.3125 35.625 40.3125Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1225 27.1875H13.1213C11.0531 27.1875 9.375 25.5094 9.375 23.4412V17.8088C9.375 15.7406 11.0531 14.0625 13.1213 14.0625H31.8788C33.9469 14.0625 35.625 15.7406 35.625 17.8088V23.685C35.625 25.62 34.0575 27.1875 32.1225 27.1875Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.81 4.6875C26.7938 4.6875 28.125 6.43312 28.125 8.05875C28.125 11.3587 22.6013 14.0625 22.5 14.0625C22.3987 14.0625 16.875 11.3606 16.875 8.05875C16.875 6.43312 18.2062 4.6875 20.19 4.6875C21.3244 4.6875 22.0687 5.21813 22.5 5.69063C22.9313 5.21813 23.6756 4.6875 24.81 4.6875Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 32.8125C38.3569 32.8125 37.3388 33.1256 36.5625 33.75C35.7862 34.3744 34.7681 34.6875 33.75 34.6875C32.7319 34.6875 31.7138 34.3744 30.9375 33.75C30.1612 33.1256 29.1431 32.8125 28.125 32.8125C27.1069 32.8125 26.0888 33.1256 25.3125 33.75C24.5362 34.3744 23.5181 34.6875 22.5 34.6875C21.4819 34.6875 20.4638 34.3744 19.6875 33.75C18.9112 33.1256 17.8931 32.8125 16.875 32.8125C15.8569 32.8125 14.8388 33.1256 14.0625 33.75C13.2862 34.3744 12.2681 34.6875 11.25 34.6875C10.2319 34.6875 9.21375 34.3744 8.4375 33.75C7.66125 33.1256 6.64312 32.8125 5.625 32.8125",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 19.6875C34.8338 19.6875 34.0425 20.0006 33.4369 20.625C32.8331 21.2494 32.0419 21.5625 31.2488 21.5625C30.4575 21.5625 29.6662 21.2494 29.0606 20.625C28.455 20.0006 27.6656 19.6875 26.8725 19.6875C26.0794 19.6875 25.29 20.0006 24.6844 20.625C24.0806 21.2494 23.2894 21.5625 22.4963 21.5625C21.7031 21.5625 20.9138 21.2494 20.3081 20.625C19.7044 20.0006 18.9131 19.6875 18.12 19.6875C17.3269 19.6875 16.5412 20.0006 15.9375 20.625C15.3338 21.2494 14.5425 21.5625 13.7494 21.5625C12.9581 21.5625 12.1669 21.2494 11.5612 20.625C10.9575 20.0006 10.1662 19.6875 9.375 19.6875",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationCake);
export default __webpack_public_path__ + "static/media/navigation-cake.a3d3f16a.svg";
export { ForwardRef as ReactComponent };